import { v4 as uuid } from 'uuid';
import { USER_DIALOG_ACTION_TYPES } from '../../constants/userDialog.constants';

export const showBulletinDialog = ({ requestId = uuid(), ...options } = {}) => ({
  type: USER_DIALOG_ACTION_TYPES.SHOW_BULLETIN_DIALOG,
  payload: { ...options, requestId },
});

export const hideBulletinDialog = (requestId) => ({
  type: USER_DIALOG_ACTION_TYPES.HIDE_BULLETIN_DIALOG,
  payload: { requestId },
});

export const bulletinDialogSaved = (bulletin, requestId) => ({
  type: USER_DIALOG_ACTION_TYPES.BULLETIN_DIALOG_SAVED,
  payload: { bulletin, requestId },
});
